// Letters (with or without accents, including combining marks), spaces, hyphens, dots for
// abbreviations (e.g. "Jr.") and apostrophes (both straight and typographic, as iOS
// keyboards insert ’ by default). Keep in sync with ticket-api `App\Rules\PersonName`.
const VALID_NAME = /^[\p{L}\p{M}\s'’.-]+$/u;

export const personName = {
  validate(value: string): boolean | string {
    return VALID_NAME.test(value) || "O nome não pode conter números ou símbolos como @.";
  },
};
